// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const SaveList: React.FC = () => {
    return <svg width="13px" height="13px" viewBox="0 0 13 13" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="VD-Set-3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="VD-Customer-Account-Quoting-Tool-–-v3" transform="translate(-52.000000, -2477.000000)" fill="currentColor" fillRule="nonzero">
            <g id="Bottom-Actions" transform="translate(40.000000, 2443.000000)">
                <g id="CTAs/Secondary-CTA-:-Icon" transform="translate(0.000000, 24.000000)">
                    <g id="Content" transform="translate(12.000000, 8.000000)">
                        <g id="↪✏️" transform="translate(0.000000, 2.000000)">
                            <path d="M12.5676341,2.81763411 L10.1330361,0.383036069 C9.93281215,0.18339307 9.49174125,0 9.17254482,0 L1.85714286,0 C0.83136143,0 0,0.83136143 0,1.85714286 L0,11.1428571 C0,12.1686386 0.83136143,13 1.85714286,13 L11.1428571,13 C12.1686386,13 13,12.1686386 13,11.1428571 L13,3.82745518 C13,3.50825875 12.8171879,3.06718785 12.5676341,2.81763411 Z M6.5,11.1428571 C5.47450903,11.1428571 4.64285714,10.3112053 4.64285714,9.28571429 C4.64285714,8.26022332 5.47450903,7.42857143 6.5,7.42857143 C7.52549097,7.42857143 8.35714286,8.26022332 8.35714286,9.28571429 C8.35714286,10.3112053 7.52433,11.1428571 6.5,11.1428571 Z M9.28571429,5.10714286 C9.28571429,5.36250009 9.07678536,5.57142857 8.82142857,5.57142857 L2.32142857,5.57142857 C2.06491082,5.57142857 1.85714286,5.36250009 1.85714286,5.10714286 L1.85714286,2.32142857 C1.85714286,2.06607178 2.06491082,1.85714286 2.32142857,1.85714286 L8.82142857,1.85714286 C9.07678536,1.85714286 9.28571429,2.06607178 9.28571429,2.32142857 L9.28571429,5.10714286 Z" id="Shape"></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(SaveList);
